const ITERABLE_API_KEY_PROD = 'cc2bfe76ec2340aea2136ea2806ae40c';
const ITERABLE_API_KEY_STAGING = 'fd95b50c6c7c40faade23db808cecfd1';
const ITERABLE_LISTS_API_KEY_PROD = '729f87887b0a4d9bb13f36ecb2ec50a5';

const SIGNUP_CHANNEL = 'web';

const ENDPOINTS = {
  UPDATE_CART: 'https://api.iterable.com/api/commerce/updateCart',
  TRACK: 'https://api.iterable.com/api/events/track',
  SUBSCRIBE: 'https://api.iterable.com/api/lists/subscribe',
  UNSUBSCRIBE: 'https://api.iterable.com/api/lists/unsubscribe',
};

const BENELUX_CONSENT_LIST_IDS = {
  BENELUX_CONSENT: 5027311,
  BENELUX_NO_CONSENT: 5027313,
};

const CONSENT_LIST_STATUS = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  ERROR: 'error',
};

export {
  ITERABLE_API_KEY_PROD,
  ITERABLE_API_KEY_STAGING,
  ITERABLE_LISTS_API_KEY_PROD,
  SIGNUP_CHANNEL,
  ENDPOINTS,
  BENELUX_CONSENT_LIST_IDS,
  CONSENT_LIST_STATUS,
};
